export default __webpack_public_path__ + "static/media/meat.d06b7825.png";